import { render, staticRenderFns } from "./DownloadWorkOrders.vue?vue&type=template&id=2f15244f&scoped=true"
import script from "./DownloadWorkOrders.vue?vue&type=script&lang=ts"
export * from "./DownloadWorkOrders.vue?vue&type=script&lang=ts"
import style0 from "./DownloadWorkOrders.vue?vue&type=style&index=0&id=2f15244f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15244f",
  null
  
)

export default component.exports